exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".seccion-error {\r\n\tborder: 2px solid red;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-editar-declaracion-sugerida/dialogo-editar-declaracion-sugerida.component.css
// module id = ../../../../../src/app/components/declaracion-sugerida/dialogo-editar-declaracion-sugerida/dialogo-editar-declaracion-sugerida.component.css
// module chunks = main